<template>
  <div :id="id" class="dialog-box">
    <div class="dialog-arrow"></div>
    <div class="dialog-content">
      <div
        v-for="type in conditionTypes"
        :key="type.value"
        class="dialog-option"
        @click="addCondition($event, type)"
      >
        {{ type.text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["trigger", "conditionTypes", "id"],
  watch: {
    trigger(value) {
      const box = document.getElementById(this.id);
      if (value) {
        box.classList.add("active");
      } else {
        box.classList.remove("active");
      }
    },
  },
  methods: {
    addCondition(e, type) {
      e.stopPropagation();
      this.$emit("addCondition", type);
    },
  },
};
</script>

<style lang="scss">
.dialog-box {
  position: absolute;
  top: 54px; /* 位於按鈕下方 */
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  // box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  // box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 5px;
  display: none; /* 初始隱藏 */
  z-index: 95;
  &.memo {
    top: 50px;
    left: 50px;
  }
  &.active {
    display: block;
  }
}

.dialog-arrow {
  position: absolute;
  top: -9px; /* 箭頭高 */
  left: 50%;
  transform: translateX(-50%);
  width: 16px;
  height: 16px;
  background: white;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
  transform: translateX(-50%) rotate(45deg);
}
.dialog-content {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 5px 0;
  max-width: 300px;
}
.dialog-option {
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  padding: 10px 16px;
  transition: all 0.3s;
  z-index: 1;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
